import { c as _c } from "react/compiler-runtime";
import Container from "@components/Container";
import MinimalFooter from "@components/MinimalFooter";
import { Button } from "@justhome/react-ui";
import { useApplicationTranslation } from "@lib/hooks/translations";
import usePartnerContext from "@lib/hooks/usePartnerContext";
import clsx from "clsx";
import { FC, PropsWithChildren } from "react";
import Fade from "./Fade";
import ProgressBarHeader from "./ProgressBarHeader";
interface SplitLayoutBodyProps extends PropsWithChildren {
  className?: string;
  innerContainerClassName?: string;
  state: any;
  currentStepNumber: number;
  numberOfSteps: number;
}
const SplitLayoutBody: FC<SplitLayoutBodyProps> = t0 => {
  const $ = _c(20);
  const {
    children,
    className,
    innerContainerClassName: t1,
    state: t2,
    currentStepNumber,
    numberOfSteps
  } = t0;
  const innerContainerClassName = t1 === undefined ? "max-w-[742px] w-full" : t1;
  const state = t2 === undefined ? 1 : t2;
  const {
    partner
  } = usePartnerContext();
  let t3;
  if ($[0] !== currentStepNumber || $[1] !== numberOfSteps) {
    t3 = <Container fullWidth={true} padding={true} className="m:hidden"><ProgressBarHeader currentStepNumber={currentStepNumber} numberOfSteps={numberOfSteps} /></Container>;
    $[0] = currentStepNumber;
    $[1] = numberOfSteps;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== className) {
    t4 = clsx("flex m:items-center justify-center grow py-m", className);
    $[3] = className;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children || $[6] !== state) {
    t5 = <Fade state={state}>{children}</Fade>;
    $[5] = children;
    $[6] = state;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== innerContainerClassName || $[9] !== t5) {
    t6 = <div className={innerContainerClassName}>{t5}</div>;
    $[8] = innerContainerClassName;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <Container fullWidth={true} padding={true} className={t4}>{t6}</Container>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = !!partner;
  let t9;
  if ($[14] !== t8) {
    t9 = <MinimalFooter isFullWidth={true} isPartner={t8} />;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t3 || $[17] !== t7 || $[18] !== t9) {
    t10 = <div className="grow flex flex-col">{t3}{t7}{t9}</div>;
    $[16] = t3;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
};
const SplitLayoutAside = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="hidden m:flex flex-none w-[400px] py-3s px-s">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const SplitLayoutMobileFooter: FC<PropsWithChildren<{
  onPrevious: () => void;
}>> = t0 => {
  const $ = _c(10);
  const {
    children,
    onPrevious
  } = t0;
  const {
    t
  } = useApplicationTranslation();
  let t1;
  if ($[0] !== onPrevious) {
    t1 = () => onPrevious();
    $[0] = onPrevious;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("link_back_previous");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <Button onClick={t1} variant="ghost" size="md" iconStart="Left" paddingX={true}>{t2}</Button>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children || $[8] !== t3) {
    t4 = <div className="fixed bottom-none left-none right-none m:hidden py-2xs px-s flex justify-between bg-neutral-0 border-t border-neutral-25">{t3}{children}</div>;
    $[7] = children;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
const SplitLayout: FC<PropsWithChildren> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="flex flex-col min-h-screen">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const SplitLayoutContent: FC<PropsWithChildren> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Container fullWidth={true} padding={true} className="flex grow">{children}</Container>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default Object.assign(SplitLayout, {
  Aside: SplitLayoutAside,
  Body: SplitLayoutBody,
  MobileFooter: SplitLayoutMobileFooter,
  Content: SplitLayoutContent
});